<li id="module-{{id}}" class="module {{key}} {{status}} {{assessmentStatus}} {{lockState}} {{groupClass}} {{dateStatus}} {{moduleClass}}" >
  {{#if use_div}}
  <div class="module-link" {{#if locked}}aria-disabled="true"{{/if}}>
  </div>
  {{else}}
  <a href="#{{#if unlocked}}{{key}}{{/if}}" class="module-link" {{#if locked}}aria-disabled="true"{{/if}} ></a>
  {{/if}}
</li>
